import { AfterViewInit, Component, ElementRef, EventEmitter, inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CubeService } from '../../services/cube.service';
import { ThemeService } from '../../services/theme.service';
import { CommonModule } from '@angular/common';
import { LangChangeEvent, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslationSyncService } from '../../services/translation-sync.service';
import { ScrollStateService } from '../../services/scroll-state.service';
import { initialOverlayState, OverlayState, OverlayStateService } from '../../services/overlay-state.service';
import { Observable } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-footer',
  imports: [CommonModule, TranslateModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent implements OnInit, AfterViewInit {
  @Input() isImprintVisible = false;
  @Input() isPrivacyPolicyVisible = false;
  activeFaces$: any;
  isDarkMode: any;
  currentLang: string;
  @ViewChild('footer', { static: false }) footerRef!: ElementRef<HTMLElement>;

  @Input() imprintBusy = false;
  @Input() privacyBusy = false;

  @Output() togglePrivacy = new EventEmitter<void>();
  @Output() toggleImprint = new EventEmitter<void>();

  private readonly overlayState = inject(OverlayStateService);

  // ✅ jetzt safe: overlayState ist sofort verfügbar
  readonly overlay = toSignal(this.overlayState.state$, {
    initialValue: initialOverlayState,
  });


  constructor(
    private router: Router,
    public cubeService: CubeService,
    private themeService: ThemeService,
    private translate: TranslateService,
    private sync: TranslationSyncService,
    public scroll: ScrollStateService) {

    this.themeService.isDarkMode$.subscribe(mode => {
      this.isDarkMode = mode;
      Promise.resolve().then(() => {
        const triggeredByToggle = this.themeService.wasThemeToggled();
        this.updateFooter(triggeredByToggle);
      });
    });
    this.activeFaces$ = cubeService.activeFaces$;
    this.router.events.subscribe(() => {
      if (this.router.url === '/imprint') {
        this.isImprintVisible = true;
      }
    });


  }


  ngAfterViewInit(): void {
    this.registerAll(this.footerRef.nativeElement);
    // Initiale Messung
    this.updateFooterHeight();
    // Reaktiv bei Größenänderung
    this.footerResizeObserver = new ResizeObserver(() => {
      this.updateFooterHeight();
    });


    this.footerResizeObserver.observe(this.footerRef.nativeElement);
  }
  ngOnInit(): void {
    // ② Auf Sprachwechsel reagieren
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.currentLang = event.lang;
      // Bei Bedarf Texte im TS-Code neu holen:
      // const title = this.translate.instant('HOME.TITLE1');
    });
    // this.registerAll(this.footerRef.nativeElement);
  }

isImprintActive(): boolean {
  const ph = this.overlay().overlays.imprint.phase;
  return ph === 'expanding' || ph === 'expanded';
}

isPrivacyActive(): boolean {
  const ph = this.overlay().overlays.privacy.phase;
  return ph === 'expanding' || ph === 'expanded';
}


  private updateFooter(triggeredByToggle: boolean): void {

    if (!this.footerRef) {
      return
    }

    const footer = this.footerRef.nativeElement;
    const footerLinks = footer.getElementsByClassName('footer-link');

    if (this.isDarkMode) {

      setTimeout(() => {
        footerLinks[0].classList.add('dark-mode');
      }, 800)

      setTimeout(() => {
        footerLinks[1].classList.add('dark-mode');
      }, 1000)

    } else {
      setTimeout(() => {
        footerLinks[0].classList.remove('dark-mode');
      }, 800)

      setTimeout(() => {
        footerLinks[1].classList.remove('dark-mode');
      }, 1000)
    }

  }

  private registerAll(root: HTMLElement) {
    const elems = Array.from(root.querySelectorAll<HTMLElement>('[data-translate]'));
    elems.forEach(el => {
      const key = el.getAttribute('data-translate')!;
      this.sync.register(el, key);
    });
  }

  private footerResizeObserver?: ResizeObserver;

  private updateFooterHeight(): void {
    if (!this.footerRef) return;


    const h = Math.round(
      this.footerRef.nativeElement.offsetHeight
    );

    document.documentElement
      .style
      .setProperty('--footer-h', `${h}px`);
  }



}
